var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomAlerts = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.748 25.745C18.145 27.07 16.778 28 15.192 28s-2.952-.929-3.556-2.255h7.112zM15.192 5.388c1.047 0 2.052.18 2.984.509v-.112C18.176 4.249 16.891 3 15.311 3h-.237c-1.58 0-2.866 1.25-2.866 2.785v.11a8.98 8.98 0 0 1 2.984-.507zm10.175 18.317a.706.706 0 0 0-.403-.81c-.076-.047-.646-.435-1.216-1.607-1.048-2.152-1.268-5.185-1.268-7.35v-.027c-.016-3.893-3.28-7.055-7.288-7.055-4.018 0-7.287 3.177-7.287 7.083 0 2.164-.22 5.197-1.268 7.349-.57 1.172-1.14 1.56-1.216 1.607a.706.706 0 0 0-.403.81c.074.34.4.573.757.573H24.61c.357 0 .683-.234.757-.573z",
    fill: "#F2AE18",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomAlerts);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-alerts.927699bb3ea7d0dd3a1e4fd282d91e08.svg";